import {FC, useEffect, useState} from "react";
import Breadcrumb from "../../../components/common/Breadcrumbs";
import {useParams} from "react-router-dom";
import ProductTabSection from "./ProductTabSection";
import {
    useGetOrderByOrderIdAndTypeQuery,
} from "../ordersApi";

const OrderDetailPage: FC = () => {

    let {orderId} = useParams();
    const orderQuery = useGetOrderByOrderIdAndTypeQuery({orderId:orderId,orderType:'OTHER'});
    const [crumbs, setCrumbs] = useState<any[]>([])

    useEffect(() => {
        if (orderQuery?.data) {
            setCrumbs([
                {content: "Home", url: "/home"},
                {content: "Orders", url: "/orders"},
                {content: orderQuery.data?.customerOrderNumber, url: ""}
            ])
            document.title = `${orderQuery?.data?.customerOrderNumber} Details`;
        }
    }, [orderQuery?.data]);

    return (
        <>
            <div className="px-5 py-5">
                <Breadcrumb crumbs={crumbs}/>
                <ProductTabSection orderQuery={orderQuery}/>
            </div>
        </>
    )
}
export default OrderDetailPage